import { render, staticRenderFns } from "./ContextSwitcher.vue?vue&type=template&id=5ea4a216"
import script from "./ContextSwitcher.vue?vue&type=script&lang=js"
export * from "./ContextSwitcher.vue?vue&type=script&lang=js"
import style0 from "./ContextSwitcher.vue?vue&type=style&index=0&id=5ea4a216&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports